import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Navbar } from "@blueprintjs/core";
const SiteNavbar = (page) => {
  const [userType, setUserType] = useState("chanel");
  const [companyID, setCompanyID] = useState("");

  const navigate = useNavigate();
  const logout = () => {
    localStorage.clear();
    navigate("/auth/login");
  };
  function underlineStyle(shouldUnderline) {
    return {
      textDecoration:
        window.location.pathname === shouldUnderline ? "underline" : "none",
      color: window.location.pathname === shouldUnderline ? "red" : "black",
    };
  }
  // const chnageZone = (zoneName) => {
  //     console.log(zoneNames.includes(zoneName));
  //     localStorage.setItem("zoneName", zoneNames.includes(zoneName) ? zoneName : "all");
  // }

  useEffect(() => {
    setUserType(localStorage.getItem("panelAccess"));
    setCompanyID(localStorage.getItem("companyID"));
  }, []);

  return (
    <React.Fragment>
      <Navbar
        className="fixed w-[100vw] h-[5rem] auth-navbar bg-black"
        style={{ zIndex: 100 }}
      >
        {/* Application Name */}
        <div className="-ml-2">
          <div className="font-semibold text-2xl text-left">{companyID}</div>
          <div>
            {userType === "admin" ? "National" : "Channel"} Manager Panel
          </div>
        </div>
        {/* <div className="navbar-left">
          <span
            onClick={() => navigate("/")}
            className={"cursor-pointer"}
            style={{
              fontSize: "1.5rem",
              fontWeight: "bolder",
              alignItems: "center",
            }}
          >
            Saathi {userType === "admin" ? "National" : "Channel"} Manager Panel
          </span>
        </div> */}
        <div className="max-w-xs text-sm breadcrumbs">
          {/*<ul>*/}
          {/*    <li>*/}
          {/*        <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0" />*/}
          {/*        <span className="material-symbols-outlined">home</span>*/}
          {/*    </li>*/}
          {/*    <li>*/}
          {/*        {window.location.pathname.split("/")[1]}*/}
          {/*    </li>*/}
          {/*</ul>*/}
        </div>

        {/* Logo */}
        <div className="navbar-right">
          <img src="/HCCB.png" alt="Coca-Cola Logo" width="100" />
        </div>
      </Navbar>

      <div
        style={{ zIndex: 10 }}
        className=" fixed flex h-screen w-16 flex-col justify-between border-e bg-white"
      >
        <div>
          <div className="inline-flex h-16 w-16 items-center justify-center">
            <span className="grid h-10 w-10 place-content-center rounded-lg bg-gray-100 text-xs text-gray-600">
              L
            </span>
          </div>

          <div className="border-t border-gray-100">
            <div className="px-2">
              <ul className="space-y-1 border-t border-gray-100 pt-4">
                <li>
                  <a
                    onClick={() => navigate("/")}
                    className="cursor-pointer group relative flex justify-center rounded px-2 py-1.5 text-gray-500 hover:bg-gray-50 hover:text-gray-700"
                  >
                    <link
                      rel="stylesheet"
                      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
                    />
                    <span
                      className={`material-symbols-outlined rounded  p-2 ${
                        window.location.pathname.split("/")[1] === ""
                          ? "bg-red-300 text-red-900"
                          : "bg-gray-200"
                      }`}
                    >
                      home
                    </span>
                    <span className="absolute start-full top-1/2 ms-4 -translate-y-1/2 rounded bg-gray-900 px-2 py-1.5 text-xs font-medium text-white opacity-0 group-hover:opacity-100">
                      Home
                    </span>
                  </a>
                </li>
                {/*<li>*/}
                {/*    <a*/}
                {/*        onClick={() => navigate("/tasksList/all")}*/}
                {/*        className="cursor-pointer group relative flex justify-center rounded px-2 py-1.5 text-gray-500 hover:bg-gray-50 hover:text-gray-700"*/}
                {/*    >*/}
                {/*        <link rel="stylesheet"*/}
                {/*              href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"/>*/}
                {/*        <span*/}
                {/*            className={`material-symbols-outlined rounded  p-2 ${window.location.pathname.split("/")[1] === "tasksList" ? "bg-red-300 text-red-900" : "bg-gray-200"}`}>task</span>*/}
                {/*        <span*/}
                {/*            className="absolute start-full top-1/2 ms-4 -translate-y-1/2 rounded bg-gray-900 px-2 py-1.5 text-xs font-medium text-white opacity-0 group-hover:opacity-100"*/}
                {/*        >*/}
                {/*            Jobs*/}
                {/*          </span>*/}
                {/*    </a>*/}
                {/*</li>*/}

                <li>
                  <a
                    onClick={() => navigate("/vendorList")}
                    className="cursor-pointer group relative flex justify-center rounded px-2 py-1.5 text-gray-500 hover:bg-gray-50 hover:text-gray-700"
                  >
                    <link
                      rel="stylesheet"
                      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
                    />
                    <span
                      className={`material-symbols-outlined rounded  p-2 ${
                        window.location.pathname.split("/")[1] === "vendorList"
                          ? "bg-red-300 text-red-900"
                          : "bg-gray-200"
                      }`}
                    >
                      supervisor_account
                    </span>
                    <span className="absolute start-full top-1/2 ms-4 -translate-y-1/2 rounded bg-gray-900 px-2 py-1.5 text-xs font-medium text-white opacity-0 group-hover:opacity-100">
                      Vendors
                    </span>
                  </a>
                </li>

                <li>
                  <a
                    onClick={() => navigate("/sellers")}
                    className="cursor-pointer group relative flex justify-center rounded px-2 py-1.5 text-gray-500 hover:bg-gray-50 hover:text-gray-700"
                  >
                    <link
                      rel="stylesheet"
                      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
                    />
                    <span
                      className={`material-symbols-outlined rounded  p-2 ${
                        window.location.pathname.split("/")[1] === "sellers"
                          ? "bg-red-300 text-red-900"
                          : "bg-gray-200"
                      }`}
                    >
                      sell
                    </span>
                    <span className="absolute start-full top-1/2 ms-4 -translate-y-1/2 rounded bg-gray-900 px-2 py-1.5 text-xs font-medium text-white opacity-0 group-hover:opacity-100">
                      STL
                    </span>
                  </a>
                </li>

                {userType === "admin" && (
                  <li>
                    <a
                      onClick={() => navigate("/channelPrograms")}
                      className="cursor-pointer group relative flex justify-center rounded px-2 py-1.5 text-gray-500 hover:bg-gray-50 hover:text-gray-700"
                    >
                      <link
                        rel="stylesheet"
                        href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
                      />
                      <span
                        className={`material-symbols-outlined rounded  p-2 ${
                          window.location.pathname.split("/")[1] ===
                          "channelPrograms"
                            ? "bg-red-300 text-red-900"
                            : "bg-gray-200"
                        }`}
                      >
                        apps
                      </span>
                      <span className="absolute start-full top-1/2 ms-4 -translate-y-1/2 rounded bg-gray-900 px-2 py-1.5 text-xs font-medium text-white opacity-0 group-hover:opacity-100">
                        Programms
                      </span>
                    </a>
                  </li>
                )}
                {userType === "admin" && (
                  <li>
                    <a
                      onClick={() => navigate("/brands")}
                      className="cursor-pointer group relative flex justify-center rounded px-2 py-1.5 text-gray-500 hover:bg-gray-50 hover:text-gray-700"
                    >
                      <link
                        rel="stylesheet"
                        href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
                      />
                      <span
                        className={`material-symbols-outlined rounded  p-2 ${
                          window.location.pathname.split("/")[1] === "brands"
                            ? "bg-red-300 text-red-900"
                            : "bg-gray-200"
                        }`}
                      >
                        rtt
                      </span>
                      <span className="absolute start-full top-1/2 ms-4 -translate-y-1/2 rounded bg-gray-900 px-2 py-1.5 text-xs font-medium text-white opacity-0 group-hover:opacity-100">
                        Brands
                      </span>
                    </a>
                  </li>
                )}
                {userType === "admin" && (
                  <li>
                    <a
                      onClick={() => navigate("/workTypes")}
                      className="cursor-pointer group relative flex justify-center rounded px-2 py-1.5 text-gray-500 hover:bg-gray-50 hover:text-gray-700"
                    >
                      <link
                        rel="stylesheet"
                        href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
                      />
                      <span
                        className={`material-symbols-outlined rounded  p-2 ${
                          window.location.pathname.split("/")[1] === "workTypes"
                            ? "bg-red-300 text-red-900"
                            : "bg-gray-200"
                        }`}
                      >
                        design_services
                      </span>
                      <span className="absolute start-full top-1/2 ms-4 -translate-y-1/2 rounded bg-gray-900 px-2 py-1.5 text-xs font-medium text-white opacity-0 group-hover:opacity-100">
                        Work Types
                      </span>
                    </a>
                  </li>
                )}

                {userType === "admin" && (
                  <li>
                    <a
                      onClick={() => navigate("/chanelManager")}
                      className="cursor-pointer group relative flex justify-center rounded px-2 py-1.5 text-gray-500 hover:bg-gray-50 hover:text-gray-700"
                    >
                      <link
                        rel="stylesheet"
                        href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
                      />
                      <span
                        className={`material-symbols-outlined rounded  p-2 ${
                          window.location.pathname.split("/")[1] ===
                          "chanelManager"
                            ? "bg-red-300 text-red-900"
                            : "bg-gray-200"
                        }`}
                      >
                        manage_accounts
                      </span>
                      <span className="absolute start-full top-1/2 ms-4 -translate-y-1/2 rounded bg-gray-900 px-2 py-1.5 text-xs font-medium text-white opacity-0 group-hover:opacity-100">
                        Chanel Manager
                      </span>
                    </a>
                  </li>
                )}

                <li>
                  <a
                    onClick={() => navigate("/outletList")}
                    className="cursor-pointer group relative flex justify-center rounded px-2 py-1.5 text-gray-500 hover:bg-gray-50 hover:text-gray-700"
                  >
                    <link
                      rel="stylesheet"
                      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
                    />
                    <span
                      className={`material-symbols-outlined rounded  p-2 ${
                        window.location.pathname.split("/")[1] === "outletList"
                          ? "bg-red-300 text-red-900"
                          : "bg-gray-200"
                      }`}
                    >
                      store
                    </span>
                    <span className="absolute start-full top-1/2 ms-4 -translate-y-1/2 rounded bg-gray-900 px-2 py-1.5 text-xs font-medium text-white opacity-0 group-hover:opacity-100">
                      Outlets
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div
          style={{ zIndex: 5000 }}
          className="sticky inset-x-0 bottom-0 border-t border-gray-100 bg-white p-2"
        >
          <button
            type="submit"
            onClick={logout}
            className="group relative flex w-full justify-center rounded-lg px-2 py-1.5 text-sm text-gray-500 hover:bg-gray-50 hover:text-gray-700"
          >
            <link
              rel="stylesheet"
              href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
            />
            <span className="material-symbols-outlined">logout</span>

            <span className="absolute start-full top-1/2 ms-4 -translate-y-1/2 rounded bg-gray-900 px-2 py-1.5 text-xs font-medium text-white opacity-0 group-hover:opacity-100">
              Logout
            </span>
          </button>
        </div>
      </div>
      <Navbar className="auth-navbar h-[10px] border-2 border-t-black">
        {/* Application Name */}
        <div className="navbar-left">
          <div className={"flex"}>
            <svg
              className="w-5 h-auto fill-current mx-2 text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="#000000"
            >
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M10 19v-5h4v5c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-7h1.7c.46 0 .68-.57.33-.87L12.67 3.6c-.38-.34-.96-.34-1.34 0l-8.36 7.53c-.34.3-.13.87.33.87H5v7c0 .55.45 1 1 1h3c.55 0 1-.45 1-1z" />
            </svg>
            {window.location.pathname}
          </div>
        </div>
        {/* Logo */}
        <div className="navbar-right justify-end mt-2">
          <div className="inline-flex">
            <button
              onClick={() => navigate("/vendorList")}
              style={underlineStyle("/vendorList")}
              className=" mr-6 font-bold text-xl  hover:text-red-600 text-slate-700 z-30 mb-0 flex w-full cursor-pointer items-center justify-center rounded-lg border-0 bg-inherit px-0 py-1 transition-all ease-in-out"
            >
              Vendors
            </button>

            <button
              onClick={() => navigate("/tasksList/all")}
              style={underlineStyle("/tasksList")}
              className="hover:text-red-600  font-bold text-xl  text-slate-700 z-30 mb-0 flex w-full cursor-pointer items-center justify-center rounded-lg border-0 bg-inherit px-0 py-1 transition-all ease-in-out"
            >
              Jobs
            </button>
          </div>
        </div>
      </Navbar>
    </React.Fragment>
  );
};
export default SiteNavbar;
